// Ensure webpack processes the main scss file.
import '../scss/main.scss';

// Register plugins
//gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

// Import core scripts
import './main/core/accessibility.js';

// Import our layout scripts
import './main/layout/header.js';
//import './main/layout/footer.js';

// Import UI scripts
// import './main/ui/buttons.js';
// import './main/ui/links.js';

// Import animation scripts
// import './main/animations/fade-in-up.js';
// import './main/animations/scroll-highlighter.js';
// import './main/animations/case-study-titles.js';

document.addEventListener("DOMContentLoaded", () => {

	// Debounce function
	const debounce = (func, delay) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), delay);
		};
	};

	// Create back to top button element
	function createBackToTopButton() {
		// Create button element
		const backToTopBtn = document.createElement('button');
		backToTopBtn.id = 'back-to-top';
		backToTopBtn.className = 'back-to-top-btn';
		backToTopBtn.setAttribute('aria-label', 'Back to top');

		// Create SVG icon
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('width', '18');
		svg.setAttribute('height', '18');
		svg.setAttribute('viewBox', '0 0 24 24');
		svg.setAttribute('fill', 'none');
		svg.setAttribute('stroke', 'currentColor');
		svg.setAttribute('stroke-width', '2');
		svg.setAttribute('stroke-linecap', 'round');
		svg.setAttribute('stroke-linejoin', 'round');

		const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		path.setAttribute('d', 'M5 15l7-7 7 7');

		svg.appendChild(path);
		backToTopBtn.appendChild(svg);

		// Append to body
		document.body.appendChild(backToTopBtn);

		// Function to check and adjust position based on reCAPTCHA presence
		function checkRecaptchaAndAdjustPosition() {
			const recaptchaBadge = document.querySelector('.grecaptcha-badge[data-style="bottomright"]');
			if (recaptchaBadge) {
				backToTopBtn.style.bottom = '90px';
			}
		}

		// Initial check
		checkRecaptchaAndAdjustPosition();

		// Set up a MutationObserver to watch for DOM changes
		const observer = new MutationObserver(function (mutations) {
			checkRecaptchaAndAdjustPosition();
		});

		// Start observing the body for child additions
		observer.observe(document.body, {childList: true, subtree: true});

		// Also check after a few seconds (fallback)
		setTimeout(checkRecaptchaAndAdjustPosition, 3000);


		return backToTopBtn;
	}

// Create the button
	const backToTopBtn = createBackToTopButton();

// Show button when page is scrolled down
	const toggleBackToTopButton = () => {
		if (window.scrollY > 300) {
			Object.assign(backToTopBtn.style, {
				opacity: '.7',
				visibility: 'visible'
			});
		} else {
			Object.assign(backToTopBtn.style, {
				opacity: '0',
				visibility: 'hidden'
			});
		}
	};

// Scroll to top when button is clicked
	backToTopBtn.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

// Use the same debounce function you already have
	window.addEventListener('scroll', debounce(toggleBackToTopButton, 10));

});